var _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "credit-card",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.125,
    height: 18.083,
    viewBox: "0 0 27.125 18.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3254",
    "data-name": "Group 3254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3253",
    "data-name": "Group 3253"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4477",
    "data-name": "Path 4477",
    d: "M24.3,85.333H2.825A2.829,2.829,0,0,0,0,88.159v12.432a2.829,2.829,0,0,0,2.825,2.825H24.3a2.829,2.829,0,0,0,2.826-2.825V88.159A2.829,2.829,0,0,0,24.3,85.333Zm1.7,15.258a1.7,1.7,0,0,1-1.7,1.7H2.825a1.7,1.7,0,0,1-1.7-1.7V88.159a1.7,1.7,0,0,1,1.7-1.7H24.3a1.7,1.7,0,0,1,1.7,1.7v12.432Z",
    transform: "translate(0 -85.333)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3256",
    "data-name": "Group 3256",
    transform: "translate(0 3.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3255",
    "data-name": "Group 3255",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4478",
    "data-name": "Path 4478",
    d: "M26.56,149.333H.565A.565.565,0,0,0,0,149.9v3.391a.565.565,0,0,0,.565.565H26.56a.565.565,0,0,0,.565-.565V149.9A.565.565,0,0,0,26.56,149.333Zm-.565,3.391H1.13v-2.26H25.995v2.26Z",
    transform: "translate(0 -149.333)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3258",
    "data-name": "Group 3258",
    transform: "translate(3.391 11.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3257",
    "data-name": "Group 3257",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4479",
    "data-name": "Path 4479",
    d: "M71.346,298.667H64.565a.565.565,0,1,0,0,1.13h6.781a.565.565,0,1,0,0-1.13Z",
    transform: "translate(-64 -298.667)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3260",
    "data-name": "Group 3260",
    transform: "translate(3.391 13.562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3259",
    "data-name": "Group 3259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4480",
    "data-name": "Path 4480",
    d: "M71.346,341.333H64.565a.565.565,0,0,0,0,1.13h6.781a.565.565,0,0,0,0-1.13Z",
    transform: "translate(-64 -341.333)",
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3262",
    "data-name": "Group 3262",
    transform: "translate(19.214 10.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3261",
    "data-name": "Group 3261",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4481",
    "data-name": "Path 4481",
    d: "M365.492,277.333h-1.13a1.7,1.7,0,0,0-1.7,1.7v1.13a1.7,1.7,0,0,0,1.7,1.7h1.13a1.7,1.7,0,0,0,1.7-1.7v-1.13A1.7,1.7,0,0,0,365.492,277.333Zm.565,2.826a.565.565,0,0,1-.565.565h-1.13a.565.565,0,0,1-.565-.565v-1.13a.565.565,0,0,1,.565-.565h1.13a.565.565,0,0,1,.565.565Z",
    transform: "translate(-362.667 -277.333)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.b5495619d21c78a7a995ab153b4f003f.svg";
export { ForwardRef as ReactComponent };